import {on, find, closest, findAllIn, hasClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import Collapse from 'bootstrap/js/dist/collapse';

export function init() {

    onFind('.js-systemfinder-tabchanger', function (element) {
        on('click', function () {
            let tab = find(element.getAttribute('data-tab'));
            tab.click();

            let anchor = find('#systemfinder-detail-anchor');
            if (anchor) {
                anchor.scrollIntoView({behavior: 'smooth'});
            }

        }, element);
    });


    onFind('.js-systemfinder-accordionchanger', function (element) {
        on('click', function () {
            let accordion = find(element.getAttribute('data-accordion'));
            new Collapse(accordion, {toggle: false}).show();

        }, element);
    });


    onFind('.js-systemfinder-active-checkbox', function (element) {
        on('click', function () {
            let parent = closest('.js-systemfinder__product', element);
            let siblings = findAllIn('.js-systemfinder-active-checkbox', parent);
            siblings.forEach(function (sibling) {
                sibling.classList.remove('checked');
            });
            element.classList.add('checked');
        }, element);
    });


    onFind('.js-systemfinder__active-tab-btn', function (element) {
        on('click', function () {
            let activeTab = element.getAttribute('data-active-tab');
            let input = document.querySelector('.js-systemfinder__active-tab-input');

            input.value = activeTab;
        }, element);
    });


    onFind('.js-systemfinder__active-accordion-btn', function (element) {
        on('click', function () {
            let parent = closest('.accordion-header', element);
            let input = findAllIn('.js-systemfinder__active-accordion-input', parent);

            //if element has class collapsed
            if (hasClass('collapsed', element)) {
                input.value = '';
            } else {
                input.value = 'active';
            }
        }, element);
    });
}